<template lang="pug">
#docContainer(v-loading='loading' element-loading-text='文档加载中...' element-loading-background='rgba(0, 0, 0, 0.5)')
  .content(ref="txt")
    .txt(v-html='content')
  application(ref='docApplication' type="txt" v-if="docloaded")
</template>

<script>
import { scanUrl, creatWatermarkUserInfo, addWaterMarker } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/views/mongeView/application.vue";
export default {
  components: { application },
  data() {
    return {
      inputText: "",
      loading: true,
      content: "",
      docloaded: false
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  created () {
    this.getFileInfo();
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await this.getRequestData(sharerId);
    },
    getRequestData(sharerId) {
      const otherData = this.docmentData;
      const txtUrl = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = txtUrl;
      document.getElementById('docContainer').appendChild(iframe);
      iframe.onload = () => {
        const content = iframe.contentWindow.document.body.innerHTML;
        this.content = content;
        addWaterMarker(document.body, creatWatermarkUserInfo());
        iframe.remove();
        this.loading = false;
        this.docloaded = true;
      };
      iframe.onerror = (e) => { this.loadingTxt = '文档加载失败'; };
    }
  }

};
</script>

<style lang="scss" scoped>
#docContainer{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.content{
  width:100%;
  height:100%;
  background-color: #E9FAFF;
  padding:7px 14px;
  color: #555;
  overflow-y:auto;
  z-index: 0.9;
}
</style>
